import { DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { toast } from '../ui/toast/use-toast';
import { AccountSortForm } from './account-sort-form';

interface Props {
  onClose: () => void;
}

export function AccountSortDialogContent({ onClose }: Props) {
  const onSuccess = () => {
    onClose();
    toast({
      title: 'Success',
      description: 'Your accounts have been sorted',
    });
  };

  return (
    <DialogContent onInteractOutside={(e) => e.preventDefault()}>
      <DialogHeader>
        <DialogTitle>Sort Accounts</DialogTitle>
      </DialogHeader>
      <DialogDescription>Click and drag the grip icons to sort your accounts and credit cards.</DialogDescription>
      <AccountSortForm onSuccess={onSuccess} />
    </DialogContent>
  );
}
